import { Component, OnChanges, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { LocalizationService } from '../../../core/localization/localization.service';
import { MappingEntry, entriesToMapping, mappingToEntries } from './workflow-operator-config.utils';

@Component({
  standalone: true,
  selector: 'ain-workflow-variable-mapping-grid',
  imports: [FormsModule, ButtonModule, InputTextModule],
  template: `
    <div class="mapping-grid">
      <div class="mapping-header">
        <span>{{ t('workflow.designer.operators.mappingKey') }}</span>
        <span>{{ t('workflow.designer.operators.mappingExpression') }}</span>
        <span></span>
      </div>
      @for (entry of entries; track $index) {
        <div class="mapping-row">
          <input pInputText [(ngModel)]="entry.key" (ngModelChange)="emitChange()" [placeholder]="t('workflow.designer.operators.mappingKeyPlaceholder')" />
          <input pInputText [(ngModel)]="entry.value" (ngModelChange)="emitChange()" [placeholder]="t('workflow.designer.operators.mappingExpressionPlaceholder')" />
          <button pButton type="button" severity="danger" icon="pi pi-trash" (click)="removeRow($index)"></button>
        </div>
      }
      <button pButton type="button" severity="secondary" size="small" icon="pi pi-plus" [label]="t('workflow.designer.operators.addMapping')" (click)="addRow()"></button>
    </div>
  `,
  styles: [`
    .mapping-grid { display: flex; flex-direction: column; gap: 6px; }
    .mapping-header, .mapping-row { display: grid; grid-template-columns: 1fr 1.4fr auto; gap: 6px; align-items: center; }
    .mapping-header span { font-size: 11px; color: #64748b; font-weight: 600; }
  `]
})
export class WorkflowVariableMappingGridComponent implements OnChanges {
  private readonly localization = inject(LocalizationService);

  readonly mapping = input<Record<string, string>>({});
  readonly mappingChange = output<Record<string, string>>();

  entries: MappingEntry[] = [{ key: '', value: '' }];

  ngOnChanges(): void {
    this.entries = mappingToEntries(this.mapping());
  }

  addRow(): void {
    this.entries = [...this.entries, { key: '', value: '' }];
  }

  removeRow(index: number): void {
    this.entries = this.entries.filter((_, rowIndex) => rowIndex !== index);
    if (this.entries.length === 0) {
      this.entries = [{ key: '', value: '' }];
    }
    this.emitChange();
  }

  emitChange(): void {
    this.mappingChange.emit(entriesToMapping(this.entries));
  }

  t(key: string): string {
    return this.localization.translate(key);
  }
}
